import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Country } from '../../types/country/country';
import { Region } from '../../types/organization/region';
import { CountryRestService } from '../../services/common/country-rest.service';
import { CountryDirectoryRestService } from '../../services/common/country-directory-rest.services';
import { AbstractSelectComponent } from '../common/abstract-select-component';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'wsd-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.css']
})
export class SelectCountryComponent extends AbstractSelectComponent<Country> implements OnInit, OnChanges {

  @Input()
  region: Region;

  @Input()
  isDisabled: boolean = false;

  @Input()
  isNew: boolean = false;

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  withInapplicable: boolean = false;

  items: SelectItem[] = [];

  countries: Country[];

  allCountries: Country[];

  @Input()
  controlName: string = 'country';

  @Input()
  showLabel: boolean = true;

  constructor(private countryRestService: CountryRestService,
    private countryDirRestService: CountryDirectoryRestService) {
    super('SELECT_COUNTRY.LABEL', 'SELECT_COUNTRY.PLACEHOLDER', 'country');
  }

  ngOnInit() {
    this.init();
    if (this.isDisabled) {
      this.parentForm.get(this.controlName).disable();
    }
  }

  ngOnChanges(changes) {
    if (changes && changes.region) {
      this.init();
      this.parentForm.get(this.controlName).setValue(null);
    }
  }

  protected init() {
    if (this.isNew) {
      this.countryDirRestService.getAllCountries().subscribe(
        (countries: Country[]) => {
          this.fillCountries(countries);
          this.allCountries = countries;
        }
      );
    } else {
      this.countryRestService.getAllCountries(this.withInapplicable).subscribe(
        (countries: Country[]) => {
          this.fillCountries(countries);
          this.allCountries = countries;
        }
      );
    }
  }

  private fillCountries(countries: Country[]) {
    this.items = [];
    this.items.push({
      label: '',
      value: null
    });
    for (const country of countries) {
      this.items.push({
        label: country.name,
        value: country
      });
    }
  }

  filterCountriesByRegion(region: Region) {
    if (this.isNew && region) {
      this.countries = [];
      for (const country of this.allCountries) {
        if (country.region.keycloakId === region.keycloakId) {
          this.countries.push(country);
        }
      }
      this.fillCountries(this.countries);
    }
  }

  filterCountries(event) {
    this.filterBy(event.query);
  }

  private filterBy(query: string) {
    this.countries = [];
    for (const country of this.allCountries) {
      if (country.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        this.countries.push(country);
      }
    }
  }

}
